<template>
  <section id="faq" class="home-section faq-section" aria-labelledby="faq-title">
    <div class="container faq-layout">
      <div class="faq-heading">
        <p class="eyebrow">04 / {{ $t(`${copyPrefix}.label`) }}</p>
        <h2 id="faq-title">{{ $t(`${copyPrefix}.title`) }}</h2>
        <p class="faq-intro">{{ $t(`${copyPrefix}.intro`) }}</p>
        <a class="text-link" href="#get-in-touch">
          {{ $t("Get In Touch") }} <i class="fa fa-arrow-right" aria-hidden="true"></i>
        </a>
      </div>
      <div class="faq-list">
        <section v-for="group in groups" :key="group.id" class="faq-group" :aria-labelledby="`faq-${group.id}-title`">
          <h3 :id="`faq-${group.id}-title`" class="faq-group-title">{{ $t(`${copyPrefix}.categories.${group.id}`) }}</h3>
          <details v-for="topic in group.topics" :key="topic" v-animated-details class="faq-item">
            <summary>
              <span>{{ $t(`${copyPrefix}.${topic}.question`) }}</span>
              <span class="faq-toggle" aria-hidden="true"></span>
            </summary>
            <div class="faq-answer">
              <p v-if="copyPrefix === 'faq' && topic === 'homeCare'">{{ $t("faq.homeCare.answer").split("heed.com.cy")[0] }}<a href="https://heed.com.cy" target="_blank" rel="noopener noreferrer">heed.com.cy</a>{{ $t("faq.homeCare.answer").split("heed.com.cy")[1] }}</p>
              <p v-else>{{ $t(`${copyPrefix}.${topic}.answer`) }}</p>
            </div>
          </details>
        </section>
      </div>
    </div>
  </section>
</template>

<script>
import { faqGroups, organisationFaqGroups } from "@/helpers/publicSeo"

export default {
  name: "PublicFaq",
  props: {
    audience: {type: String, default: "professional", validator: value => ["professional", "organisation"].includes(value)}
  },
  computed: {
    groups() { return this.audience === "organisation" ? organisationFaqGroups : faqGroups },
    copyPrefix() { return this.audience === "organisation" ? "organisationFaq" : "faq" }
  }
}
</script>

<style scoped lang="scss">
.faq-section {
  background: #fff;
  scroll-margin-top: 110px;
}
.faq-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.5fr);
  gap: 72px;
  align-items: start;
}
.faq-intro {
  color: var(--care-muted);
  line-height: 1.8;
  margin: 22px 0 26px;
}
.faq-list {
  min-width: 0;
}
.faq-group + .faq-group { margin-top: 32px; }
.faq-group-title {
  margin: 0;
  padding: 0 4px 12px;
  border-bottom: 1px solid var(--care-line);
  color: var(--care-primary);
  font-size: 16px;
  font-weight: 700;
  line-height: 1.5;
}
.faq-item {
  border-bottom: 1px solid var(--care-line);

  summary {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
    padding: 24px 4px;
    color: var(--care-ink);
    font-size: 18px;
    font-weight: 600;
    line-height: 1.5;
    list-style: none;
    cursor: pointer;

    &::-webkit-details-marker { display: none; }
    &:hover { color: var(--care-primary); }
    &:focus-visible {
      outline: 2px solid var(--care-primary);
      outline-offset: 4px;
      border-radius: 4px;
    }
  }
}
.faq-toggle {
  position: relative;
  flex: 0 0 28px;
  height: 28px;
  border-radius: 50%;
  background: var(--care-paper);
  color: var(--care-primary);

  &::before, &::after {
    content: "";
    position: absolute;
    background: currentColor;
    inset: 13px 8px;
  }
  &::after { transform: rotate(90deg); }
}
.faq-item[open] .faq-toggle::after { transform: rotate(0); }
.faq-answer {
  padding: 0 56px 24px 4px;
  color: var(--care-muted);
  line-height: 1.85;

  p { margin: 0; }
  a { text-decoration: underline; }
}
@media (max-width: 767px) {
  .faq-layout { grid-template-columns: minmax(0, 1fr); gap: 32px; }
  .faq-item summary { font-size: 16px; gap: 16px; }
  .faq-answer { padding-right: 4px; }
}
</style>
